import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aa23a3e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-content"
};
const _hoisted_2 = {
  key: 0,
  class: "contrast-color-text"
};
import { computed } from 'vue';
import { isValidURL } from '@/utils/strings';
export default /*#__PURE__*/_defineComponent({
  __name: 'ColumbiaSelfReportFormResourceItem',
  props: {
    severity: {},
    headerList: {},
    bulletList: {}
  },
  setup(__props) {
    _useCssVars(_ctx => ({
      "7b9df949": colorContrast.value,
      "0e7df39a": headerColor.value
    }));
    const props = __props;
    const headerColor = computed(() => props.severity === 'high' ? '#fc0001' : props.severity === 'medium' ? '#fdc202' : '#ffff00');
    const colorContrast = computed(() => `var(--ion-color-${props.severity === 'high' ? 'danger' : 'warning'}-contrast)`);
    const headerElements = computed(() => props.headerList.map(headerElement => {
      return {
        text: headerElement,
        isValidURL: isValidURL(headerElement)
      };
    }));
    function openDocument(src) {
      const documentUrl = new URL(src);
      window.open(documentUrl);
    }
    return (_ctx, _cache) => {
      const _component_ion_text = _resolveComponent("ion-text");
      const _component_ion_item = _resolveComponent("ion-item");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_ion_item, {
        class: "font-size-m",
        lines: "none"
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerElements.value, (headerElement, index) => {
          return _openBlock(), _createBlock(_component_ion_text, {
            class: _normalizeClass(["header-text", {
              pointer: headerElement.isValidURL
            }]),
            key: index,
            onClick: $event => headerElement.isValidURL ? openDocument(headerElement.text) : undefined,
            color: headerElement.isValidURL ? 'primary' : ''
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(`${headerElement.text} `), 1)]),
            _: 2
          }, 1032, ["onClick", "class", "color"]);
        }), 128))])]),
        _: 1
      }), _ctx.bulletList ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bulletList, (bullet, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createVNode(_component_ion_text, {
          class: "contrast-color-text"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(bullet), 1)]),
          _: 2
        }, 1024)]);
      }), 128))])) : _createCommentVNode("", true)], 64);
    };
  }
});